export const Type = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="5" width="26" height="22" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M8 23V11C8 10.4477 8.44772 10 9 10H13C13.5523 10 14 10.4477 14 11V23" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M8 17H14" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M18 14H23C23.5523 14 24 14.4477 24 15V22H19C18.4477 22 18 21.5523 18 21V19C18 18.4477 18.4477 18 19 18H23.5" stroke="currentColor" stroke-width="2"/>
</svg>`;
